import React from 'react'
import { Typography,  Accordion, AccordionActions, AccordionSummary, AccordionDetails } from '@mui/material'
import { ExpandMoreOutlined } from '@mui/icons-material'

export const CardCommonExpandible = ({ className, defaultExpanded, ...props }) => {
  return (
    <Accordion className={`uiCardCommonExpandible ${className || ''}`} {...props} defaultExpanded={defaultExpanded}>
      <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
        <Typography>{props.title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {props.children}
      </AccordionDetails>
      {props.actions &&
        <AccordionActions>
          {props.actions}
        </AccordionActions>
      }
    </Accordion>
  )
}
